import "../styles/globals.scss";
import Head from "next/head";
import { QueryClient, QueryClientProvider } from "react-query";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "../src/theme/theme";
import { SnackbarProvider } from "notistack";
import "../styles/menu.scss";
import type { AppProps } from "next/app";
import { LazyMotion, domAnimation, AnimatePresence } from "framer-motion";
import { CookieConsentProvider } from "@use-cookie-consent/react";
import dynamic from "next/dynamic";
import "@/src/i18n";

const AnalyticsProviderDynamic = dynamic(
  import("../components/analytics/analytics-provider"),
  {}
);

const queryClient = new QueryClient();

const MyApp = ({ Component, pageProps, router }: AppProps) => {
  return (
    <>
      <Head>
        <title>Pivovarská restaurace Čáslav</title>
        {/* <meta name="description" content="" /> */}
        <link rel="icon" href="/fav/fav.png" />
      </Head>
      <>
        <CookieConsentProvider
          useCookieConsentHooksOptions={{
            consentCookieAttributes: { expires: 365 },
          }}
        >
          <AnalyticsProviderDynamic />
          <ThemeProvider theme={theme(false)}>
            <CssBaseline />
            {/* @ts-ignore */}
            <SnackbarProvider maxSnack={3} >
              <QueryClientProvider client={queryClient}>
                <LazyMotion features={domAnimation}>
                  <AnimatePresence exitBeforeEnter initial={true}>
                    {/* @ts-ignore */}
                    <Component {...pageProps} key={router.route} />
                  </AnimatePresence>
                </LazyMotion>
              </QueryClientProvider>
            </SnackbarProvider>
          </ThemeProvider>
        </CookieConsentProvider>
      </>
    </>
  );
};

export default MyApp;
